<template>
  <div class="class-add">
    <GlobalChunk :icon="DetailIMG" :title="titleDetail" :padding="[32, 0, 95, 55]">
      <el-row>
        <el-col :span="10">
          <GlobalForm :init-data="initData" :form-rules="formRules" :form-item-list="formItemList" :labelWidth="80"
            @handleConfirm="handleConfirm" confirmBtnName="提交">
            <el-form-item class="el_from" label-width="100px" label="上传广告图" slot="operationIcon" :required="true">
              <div class="el_from_content">
                <div class="el_from_content_item">
                  <ElImgUpload key="clickLogo" :exist-image="clickLogo" @handleDelete="handleDelete('clickLogo')"
                    @handleChange="handleChange($event, 'clickLogo')" />
                  <!-- <span>选中传白色图标</span> -->
                </div>
              </div>
              <span class="tip">只能上传一张图片，文件格式为jpg/png/gif/jpeg，文件大小不的超过500KB，建议尺寸:750*460px</span>
            </el-form-item>
            <!-- <el-form-item class="el_from" label="是否上架" slot="operationEnable" :required="true">
              <el-switch inactive-color="#bebebe" @change="handleSwitch" v-model="isEnable"></el-switch>
            </el-form-item> -->
            <Provinces slot="provinces" />
            <el-button slot="btnSlot" @click="FromBack">返回</el-button>
            <el-button slot="btnRitslot" type="primary" @click="seeSampleImage">预览</el-button>
          </GlobalForm>
        </el-col>
      </el-row>
    </GlobalChunk>
    <el-image-viewer v-if="showViewer" :on-close="
      () => {
        showViewer = false;
      }
    " :url-list="imgList" />
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import ElImgUpload from "../../../components/global/components/elements/upload-element";
import Provinces from "@/components/plugins/provinces";
import { http } from "../../../utils/request/newIndex";
export default {
  name: "class-add",
  components: { Provinces, ElImgUpload, ElImageViewer },
  data() {
    return {
      titleDetail: "添加广告",
      DetailIMG: "add",
      classFormData: [],
      clickLogo: "",
      isEnable: false,
      showViewer: false,
      imgList: [],
      initData: {
        adName: "",
      },
      i: "",
      option: [
        { label: "是", value: "01" },
        { label: "否", value: "02" },
      ],
      formItemList: [
        {
          key: "adName",
          type: "input",
          labelName: "广告名称",
          placeholder: "请输入广告名称（广告名称不会展示在小程序前端，限20字内）",
        },
        { slotName: "operationIcon" },
        // { slotName: "operationEnable" },
      ],

      formRules: {
        adName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入广告名称（广告名称不会展示在小程序前端，限20字内）",
            max: 20,
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.query.type === "edit") {
      this.DetailIMG = "edit";
      this.titleDetail = "编辑广告";
      http.getAdvertsdetlai({ id: this.$route.query.id }).then((res) => {
        if (res.code === 1) {
          console.log(res.data);
          this.classFormData = res.data;
          this.initData.adName = this.classFormData.adName;
          this.clickLogo = this.classFormData.adImg;
          // this.isEnable = this.classFormData.isEnable;
        } else {
          this.$message.error("res.msg");
        }
      });
    } else {
      this.titleDetail = "添加广告";
      this.DetailIMG = "add";
    }
  },
  methods: {
    // 查看示例图大图
    seeSampleImage() {
      if (this.clickLogo) {
        this.imgList = [];
        this.showViewer = true;
        this.imgList.push(this.clickLogo);
      } else {
        this.$message.error("请上传广告图");
      }

    },
    // 图标上传回调
    handleChange(e, val) {
      console.log(e);
      if (val == "clickLogo") {
        this.clickLogo = e
      }
    },
    handleDelete(val) {
      console.log(val);
    },
    // 是否禁用开关
    handleSwitch(e) {
      this.isEnable = e
    },
    handleConfirm(data, cd) {
      console.log(data);
      // const classAddOrUpdateDto = {
      //   name: data.machineTypeName,
      //   logo: this.logo,
      //   clickLogo: this.clickLogo,
      //   id: this.classFormData.id?this.classFormData.id:"",
      //   isEnable: this.isEnable,
      //   isHasIos: data.isHasIos,
      //   showSpec: data.showSpec,
      //   remark: data.remark?data.remark:"",
      // };
      const classAddOrUpdateDto = {
        "adImg": this.clickLogo,
        "adName": data.adName,
        "adType": "01",
        "adValue": "",
        "id": this.classFormData.id ? this.classFormData.id : "",
      };
      console.log(classAddOrUpdateDto);
      if (this.$route.query.type === "edit") {
        http.addOrUpdateAdverts(classAddOrUpdateDto).then((res) => {
          if (res.code === 1) {
            this.$router.push({ path: "/OnlinreyService/advertManagement" });
            this.$message({
              message: res.msg,
              type: "success",
            });
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        });
      } else {
        http.addOrUpdateAdverts(classAddOrUpdateDto).then((res) => {
          if (res.code === 1) {
            this.$router.push({ path: "/OnlinreyService/advertManagement" });
            this.$message({
              message: "添加成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "添加失败",
              type: "error",
            });
          }
        });
      }
    },
    FromBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style  scoped lang="scss" ref="stylesheet/scss">
/deep/.el-button {
  margin-right: 50px;
}

.class-add {
  .el_from {
    margin-left: -99px;

    .el_from_content {
      display: flex;

      .el_from_content_item {
        margin-right: 51px;
      }

      div {
        text-align: center;
        color: #666666;

        /deep/.el-upload {
          background-color: #F5F6FC;
        }
      }
    }

    .tip {
      color: #FF687B;
    }
  }

  /deep/.el_from_hasIos {
    .el-form-item__label {
      line-height: 20px;
      text-align: left;
      padding-left: 12px;
      position: relative;
    }

    .el-form-item__label::before {
      position: absolute;
      left: 3px;
    }
  }
}

/deep/.global-chunk {
  background-color: #fff;
}

/deep/.global-chunk_header {
  border-bottom: 1px solid #EDEFFD;
  border-radius: 20px 20px 0 0;
  margin-bottom: 0px;
}
</style>